import { validationMessages } from '../../translations'

export function minLength(value, min, formatMessage = undefined) {
  const error =
    (formatMessage && formatMessage(validationMessages.minLength, { min })) ||
    `Must be at least ${min} characters`

  return value?.trim()?.length >= min ? undefined : error
}
